module.exports = __webpack_public_path__ + "static/media/DK1050_03.4f3cf5ff.jpg";